export const http = {
  yourAccountHasLoggedInElsewhere:
    "Your account is currently signed in elsewhere.",
  loginExpiration: "Session Timed Out!",
  NoAccess: "No access.",
  unknownErrorPleaseTryAgainLater: "Unknown error, please try again later.",
  networkError: "Network error.",
  accountDelete: "Account Deleted",
  tokenInvalid: "Token is invalid",
  yourAccountHasBeenRemoved:
    "Your account has been deleted and you have been automatically signed out. If you believe this is an error please check with your VIA CWorkX Connect Cloud Administrator.",
};
